import Component from '@glimmer/component';

import { service } from '@ember/service';

import SearchTerm from 'rise-ui/components/search-term.gjs';

export default class CatalogSearchTermComponent extends Component {
  @service('catalog/search') search;

  <template>
    <SearchTerm
      @route={{this.search.linkToCommit}}
      @placeholder="Search Datasets"
      @value={{this.search.editedTerm}}
      @refresh={{this.search.isDirty}}
      @loading={{this.search.results.isPending}}
      @onInput={{this.search.editTerm}}
    />
  </template>
}
